import React from 'react'
import {useTranslation} from 'react-i18next'

import {FormControl, MenuItem, Select} from '@mui/material'

export type ConsultationTypeFilter = 'all' | 'emotional_program' | 'general'

export interface ConsultationTypeFilterDropdownProps {
  value: ConsultationTypeFilter
  onChange: (value: ConsultationTypeFilter) => void
}

const ConsultationTypeFilterDropdown: React.FC<
  ConsultationTypeFilterDropdownProps
> = ({value, onChange}) => {
  const {t} = useTranslation()
  return (
    <FormControl size='small' sx={{minWidth: 200, marginLeft: 'auto'}}>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as ConsultationTypeFilter)}
        displayEmpty
        inputProps={{
          'aria-label': t('consultations_upcoming_filter_all_types'),
        }}
      >
        <MenuItem value='all'>
          {t('consultations_upcoming_filter_all_types')}
        </MenuItem>
        <MenuItem value='emotional_program'>
          {t('consultations_upcoming_filter_emotional_program')}
        </MenuItem>
        <MenuItem value='general'>
          {t('consultations_upcoming_filter_general')}
        </MenuItem>
      </Select>
    </FormControl>
  )
}

export default ConsultationTypeFilterDropdown
